import Vue from "vue";
import { VueConstructor } from "vue/types/umd";

const req: any = require.context("./", true, /\.vue$/);
const requireAll = (context: any) => {
  return context.keys().map((d: any) => {
    return context(d).default;
  });
};

const constructors: VueConstructor[] = requireAll(req);

const widgets: { [prop: string]: VueConstructor } = {};

const magics: { [prop: string]: VueConstructor } = {};

constructors.forEach((component: any) => {
  const name = component.options.name as string;
  if (name.indexOf("Magic") >= 0) {
    magics[name] = component;
  } else {
    widgets[name] = component;
    Vue.component(name, component);
  }
});

export const magicWidgets = magics;

export default widgets;
